import Transport, { limit, offset } from '../../common/services/api/Transport';

const transport = new Transport();

export const getMeetingPolicies = async meetingId => {
    try {
        const result = await transport.get({ path: `meetings/${meetingId}/policies` });
        return result.data.statusCode === 200 ? result.data.data.policies : [];
    } catch (error) {
        return null;
    }
};

export const getPolicies = async pageNumber => {
    try {
        const result = await transport.get({ path: `policies?limit=${limit}&offset=${offset(pageNumber)}` });
        return result.data.statusCode === 200
            ? { ...result.data.data, count: Math.ceil(result.data.data.count / limit) }
            : {};
    } catch (error) {
        return null;
    }
};

export const getPolicy = async policyId => {
    try {
        const result = await transport.get({ path: `policies/${policyId}` });
        return result.data.statusCode === 200
            ? { ...result.data.data, pageNumber: Math.ceil(result.data.data.index / limit) }
            : {};
    } catch (error) {
        return null;
    }
};

export const getPoliciesAcl = async meetingId => {
    try {
        const result = await transport.get({ path: `meetings/${meetingId}/policies/acl` });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const createPolicy = async (meetingId, policyData) => {
    try {
        const result = await transport.post({ path: `meetings/${meetingId}/policies`, data: policyData });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const updatePolicy = async (meetingId, policyData) => {
    try {
        const result = await transport.put({
            path: `meetings/${meetingId}/policies/${policyData._id}`,
            data: policyData,
        });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const deletePolicy = async (meetingId, policyId) => {
    try {
        const result = await transport.delete({ path: `meetings/${meetingId}/policies/${policyId}` });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};
